import { get, map } from 'lodash-es';
import { createSelector } from 'reselect';
import { commentModel } from 'common/api/models';

export const getVideoCommentsSelector = createSelector(
  (state) => state.videoComments,
  (videoComments) => map(get(videoComments, 'comments'), (item) => commentModel(item))
);

export const getVideoCommentsShowSelector = createSelector(
  (state) => state.videoComments,
  (videoComments) => videoComments.show
);

export const getVideoCommentsListLoadingSelector = createSelector(
  (state) => state.videoComments,
  (videoComments) => videoComments.loading
);

export const getVideoCommentsFormShowSelector = createSelector(
  (state) => state.videoComments,
  (videoComments) => videoComments.showForm
);

export const getVideoCommentsFormAddingSelector = createSelector(
  (state) => state.videoComments,
  (videoComments) => videoComments.adding
);

export const getVideoCommentsFormSuccessSelector = createSelector(
  (state) => state.videoComments,
  (videoComments) => videoComments.showSuccessMsg
);
